import { Link } from 'react-router-dom';
import { GUIDES } from '../guides/guidesContent';

export default function LandingFooter() {
  return (
    <footer className="landing-footer">
      <div className="landing-wrap">
        <p className="landing-footer-brand">miD · Mediador Imobiliário Digital</p>
        <nav aria-label="Guias">
          {GUIDES.map((guide) => <Link key={guide.path} to={guide.path}>{guide.navLabel}</Link>)}
        </nav>
        <nav aria-label="miD">
          <Link to="/precos-agentes">Para agentes imobiliários</Link>
          <Link to="/intermediary/login">Para intermediários de crédito</Link>
          <Link to="/login">Entrar</Link>
          <Link to="/terms">Termos</Link>
          <Link to="/privacy">Privacidade</Link>
          <Link to="/cookies">Cookies</Link>
          <a href="mailto:geral@mediadorimobiliariodigital.com">Contacto</a>
        </nav>
        <p>© {new Date().getFullYear()} miD</p>
      </div>
    </footer>
  );
}
